import { unifiedAgentEvent } from './unifiedAgentEvent'

export const unifiedAgentActivatedLogEvent = unifiedAgentEvent<{
  agent_id: number
  activated_from_draft: boolean
  prompt_count?: number
}>('Unified_Agent_Activated')
